import http from '@/requests/http'

class Department {
  static all (params) {
    return http.post('configuration/consultation/department/index', params)
  }
  static async view (params) {
    return http.post('configuration/consultation/department/view', params)
  }
  static async update (data) {
    return http.post('configuration/consultation/department/update', data)
  }
  static async save (data) {
    return http.post('configuration/consultation/department/store', data)
  }
  static async delete (id) {
    return http.post(`configuration/consultation/department/delete/${id}`)
  }
}

export default Department
